import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {Spinner} from '@npck/libs/commons';
import {initialTableEvent} from '../full-table.component';

export const INITIAL_PAGE_NUMBER = 0;
export const INITIAL_PAGE_SIZE = 10;

@Component({
    selector: 'af-paginator',
    templateUrl: 'paginator.component.html',
    styleUrls: ['paginator.component.scss'],
    standalone: false
})
export class PaginatorComponent implements OnInit {
    @Input() totalElements: number;
    @Input() spinnerIds: string[];
    @Output() pageChangeListener = new EventEmitter<PageEvent>();
    @Output() scrollEmitter = new EventEmitter<boolean>();
    @Input() pageSizes: number[] = [10, 50, 100];
    @Input() currentPageEvent: PageEvent;
    INITIAL_PAGE_NUMBER = INITIAL_PAGE_NUMBER;

    @HostBinding('class.d-none') get displayNone(): boolean {
        return Spinner.isShown(...this.spinnerIds) || !this.totalElements;
    }

    get totalPages(): number {
        return Math.ceil(this.totalElements / this.currentPageEvent.pageSize);
    }

    ngOnInit(): void {
        if (!this.currentPageEvent) {
            this.currentPageEvent = initialTableEvent.page;
        }
    }

    emitPageChanges(number: number): void {
        this.currentPageEvent = {
            ...this.currentPageEvent,
            pageNumber: this.currentPageEvent.pageNumber + number,
            pageOffset: (this.currentPageEvent.pageNumber + number) * this.currentPageEvent.pageSize,
        };
        this.emitValueChanges();
        this.scrollEmitter.emit(true);
    }

    emitPageSizeChanged(size: number): void {
        const totalPagesBeforeChangingSize = this.totalPages;
        this.currentPageEvent = {
            pageSize: size,
            pageNumber: INITIAL_PAGE_NUMBER,
            pageOffset: INITIAL_PAGE_NUMBER * size,
        };
        const totalPagesAfterChangingSize = this.totalPages;
        if (totalPagesBeforeChangingSize != totalPagesAfterChangingSize) {
            this.emitValueChanges();
        }
    }

    reset(): void {
        this.currentPageEvent = {
            ...this.currentPageEvent,
            pageNumber: INITIAL_PAGE_NUMBER,
        };
    }

    private emitValueChanges(): void {
        this.pageChangeListener.emit(this.currentPageEvent);
    }

}

export interface PageEvent {
    pageSize: number;
    pageNumber: number;
    pageOffset: number;
}
